import React, { useEffect, useState, useContext } from "react";
import styles from "./List.module.css";
import plusIcon from "../../assets/Home/icon-plus.svg";
import filterIcon from "../../assets/Home/Filter-Icon.svg";
import IconArrow from "../../assets/icons/Black/arrow-left.svg";
import departmentIcon from "../../assets/Home/DepartamentIcon.svg";
import { Card } from "../Card/Card";
import { NemuContext } from "../../utils/NemuContext";
import { useAuth } from "../../context/AuthContext";
import Loader from "../Loader/Loader";

function List(props) {
  const { user, createDraftProject } = useAuth();
  const { setSelectedProp } = useContext(NemuContext);
  const [searchProp, setSearchProp] = useState("");
  const [sortOption, setSortOption] = useState("lastUpdated");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedProjects, setSortedProjects] = useState([]);
  const [filterByStatus, setFilterByStatus] = useState("all");

  useEffect(() => {
    let sorted = [...props.projects];
    sorted.sort((a, b) => {
      if (sortOption === "name") {
        return sortOrder === "asc"
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name);
      } else if (sortOption === "lastUpdated") {
        return sortOrder === "asc"
          ? new Date(a.lastInventoryUpdate) - new Date(b.lastInventoryUpdate)
          : new Date(b.lastInventoryUpdate) - new Date(a.lastInventoryUpdate);
      } else {
        return 0;
      }
    });
    setSortedProjects(sorted);
  }, [props.projects, sortOption, sortOrder]);

  function getStatusColor(status) {
    if (status === "Publicado")
      return { border: "#129B12", bgcolor: "#E6F2D1" };
    if (status === "Borrador") return { border: "#4C63ED", bgcolor: "#E5E1FC" };
    if (status === "Cerrado")
      return { border: "#282827", bgcolor: "transparent" };
    if (status === "Error")
      return { border: "#FF6F43", bgcolor: "transparent" };
    if (status === false) return { border: "#FF6F43", bgcolor: "transparent" };
    if (status === true) return { border: "#FF6F43", bgcolor: "transparent" };
    return { border: "#FF6F43", bgcolor: "transparent" };
  }

  // // Check if both user and projects are loaded
  if (!user || !props.projects) {
    return (
      <div className={styles["container-list"]}>
        <div className={styles["add-container"]}>
          <Loader />
        </div>
      </div>
    );
  }

  const createDraft = async (id) => {
    try {
      const response = await createDraftProject(id);
      console.log('Response en list', response.developments.id);
      setSelectedProp(response.developments.id);
    } catch (error) {
      console.error("Error creating draft project:", error);
    }
  }

  return (
    <div className={styles["container-list"]}>
      <div className={styles["add-container"]}>
        <div className={styles.but}>
          <img src={plusIcon} alt="Plus Icon" />
          <button
            onClick={() => {
              createDraft(user.id);
            }}
          >
            Nuevo Proyecto{" "}
          </button>
        </div>
        <div className="flex justify-between items-center gap-0 w-full">
          <div className="flex items-center">
            <img src={departmentIcon} alt="Department Icon" />
            <span onClick={() => console.log(sortedProjects)} className="text-lg">{sortedProjects.filter(p => p.status === "Publicado").length}/{sortedProjects.length}</span>
          </div>
          <div className="flex items-center">
            <p onClick={() => setSortOption(prev => prev === 'lastUpdated' ? 'name' : 'lastUpdated')} className="py-1 px-2 rounded-full cursor-pointer hover:bg-black/10">{sortOption === 'lastUpdated' ? 'Última act.' : 'Nombre'}</p>
            <img onClick={() => setSortOrder(prev => prev === "desc" ? "asc" : "desc")} src={IconArrow} alt="Arrow Icon" className={`w-8 h-8 p-2 rounded-full bg-white cursor-pointer hover:invert ${sortOrder === "desc" ? "rotate-90" : "-rotate-90"}`}/>
          </div>
        </div>
        {/* <img src={filterIcon} alt="Filter Icon" /> */}
      </div>
      <div className={styles["proyect-container"]}>
        <select value={filterByStatus} onChange={(e) => setFilterByStatus(e.target.value)} className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black">
          <option value="all">Todos los estados</option>
          <option value="Publicado">Publicado</option>
          <option value="Borrador">Borrador</option>
          <option value="Vendido">Vendido</option>
        </select>
        <input type="text" className="w-full pl-3 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey" onChange={(e) => setSearchProp(e.target.value)} placeholder="Buscar por nombre" />
        {sortedProjects.filter(p => p.name.toLowerCase().includes(searchProp.toLowerCase()) && (filterByStatus === "all" || p.status === filterByStatus)).map((style, index) => (
          <Card
            key={index}
            id={style.id}
            text={style.status}
            title={style.name}
            location={style.address}
            date={style.lastInventoryUpdate}
            published={style.status}
            pinned={!style.is_private}
          />
        ))}
      </div>
    </div>
  );
}
 
export { List };
